import { render, staticRenderFns } from "./settingParamsModel.vue?vue&type=template&id=8718d29c"
import script from "./settingParamsModel.vue?vue&type=script&lang=js"
export * from "./settingParamsModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports